    <!--
    Desarrollado por: Wuilmer garcia
    // Fecha: 2021/09/20
    // Modificado por: Wuilmer Garcia
    // Fecha de ultima Modificacion:  2022-03-30 
    // Causa: fase 03 evaluacion

    Historial de Modificaciones
    // Fecha Modificación: 
    // Modificación: Creación del componente
    /////////////////////////////////////////////////
-->

<template>
    <div>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>

        <v-row v-if="componenteEvento.agregar_submodulo">
            <v-col cols="12" class="d-flex flex-row-reverse">
                <TableButtonComp @click="addItem()" normalButton textButton="Registrar incidencias" iconBut="fas fa-plus" />
            </v-col>

            <v-col cols="12" sm="4" md="">
                <AutocompleteComp textLabel="Nivel" v-model="filter.id_nivel" @change="eventNivel(filter.id_nivel)"
                    :items="listNivel" item-value="id" item-text="desc_nivel" />
            </v-col>

            <v-col cols="12" sm="4" md="">
                <AutocompleteComp textLabel="Periodo" v-model="filter.id_periodo" @change="eventPeriodo(filter.id_periodo)"
                    :items="listPeriodo" item-value="id" item-text="nombre_periodo" />
            </v-col>


            <v-col cols="12" sm="4" md="">
                <AutocompleteComp textLabel="Grado" v-model="filter.id_grado" @change="eventGrado(filter.id_grado)"
                    :items="listGrado" item-value="id" item-text="desc_grado" />
            </v-col>

            <v-col cols="12" sm="4" md="">
                <AutocompleteComp textLabel="Sección" v-model="filter.id_seccion" @change="eventSeccion(filter.id_seccion)"
                    :items="listSeccion" item-value="id" item-text="nombre_seccion" />
            </v-col>


            <v-col cols="12" sm="4" md="">
                <AutocompleteComp textLabel="Estudiante" v-model="filter.id_alumno" @change="getIncidenciaCoductual(filter)"
                    :items="listAlumno" item-value="id" item-text="nombre_apellido" />
            </v-col>


            <v-col cols="12" sm="4" md="">
                <AutocompleteComp textLabel="Tipo de incidencia" v-model="filter.id_tipo_incidencia"
                    :items="listTipoIncidencia" item-text="descripcion" item-value="id"
                    @change="getIncidenciaCoductual(filter)" />
            </v-col>

        </v-row>
        <v-row>
            <v-col cols="12">
                <ComundataTablecompVue whitSearch noResultsText="Sin datos para mostrar"
                    placeholderTextsearch="Buscar por DNI" :headers="RegIncidenciaConductheaders" :items="data"
                    :search="search">

                    <template v-slot:fecha="{ item }">
                        {{ item.fecha | filtroFecha }}
                    </template>

                    <template v-slot:action_ap_nombre="{ item }">
                        {{ item.ape1_persona + " " + item.ape2_persona + " " + item.nombre_persona }}
                    </template>

                    <template v-slot:action_ver="{ item }">
                        <TableButtonComp v-if="componenteEvento.visualizar_submodulo" verButton tooltipText="Ver incidencia"
                            @click="viewItem(item)" />
                    </template>

                    <template v-slot:action_editar="{ item }">
                        <TableButtonComp v-if="componenteEvento.editar_submodulo" editButton tooltipText="Editar incidencia"
                            @click="editItem(item)" />
                    </template>
                    <template v-slot:action_borrar="{ item }">
                        <TableButtonComp v-if="componenteEvento.borrar_submodulo" deleteButton
                            tooltipText="Eliminar incidencia" @click="deleteItem(item.id)" />
                    </template>
                </ComundataTablecompVue>
            </v-col>
        </v-row>



        <span v-if="test">
            Datos: <code>{{ data }}</code>

        </span>

        <!-- fin consulta -->



        <!-- END de modal para visualizar Imagen-->
        <component :is="compName" :estadoModal="estadoModalConfig" :parametros="parametroConfig" @close="closeModal">
        </component>

        <confirm @aceptar="deleted" @cancelar="cancelar" titleWindow="Eliminar incidencia" :title="confirm.title"
            :active="confirm.active" />

    </div>
</template>

<script>

import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { RegIncidenciaConductheaders } from '../../../helpers/headersTable'
import ComundataTablecompVue from "@/components/ComponentsEst/ComundataTablecomp.vue"
import ConductualFormComp from './components/ConductualFormComp'
import TableButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import AutocompleteComp from '../../../components/ComponentsEst/AutocompleteComp.vue';
export default {
    name: 'IncidenciaConductual',

    components: {
        ConductualFormComp,
        ComundataTablecompVue,
        TableButtonComp,
        AutocompleteComp
    },
    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        rutaservidor: API_URL,
        paramComponente: { "id_modulo": 8, 'id_submodulo': 94 }, //sud_modulo y modulo
        datoLogin: sessionStorage, // variables de sesion del usuario
        test: false,

        confirm: {
            id: 0,
            title: "",
            active: false,
        },
        ////////////////////////////////////////////////////////


        //// CONSULTA PRINCIPAL
        // evento: 'agregar',
        RegIncidenciaConductheaders,
        search: '',
        data: [],
        filter: {},
        listPeriodo: [],

        listNivel: [],
        listGrado: [],
        listSeccion: [],
        listAlumno: [],
        listTipoIncidencia: [],

        // formTitle: 'Visualizar Galeria del Gestor de Contenido',
        // componente Fomulario Colegio
        compName: null,
        estadoModalConfig: true,
        parametroConfig: [],

    }),

    //computadas
    computed: {
        ...mapGetters('login', ['componenteEvento'])

    },

    mounted() {
        this.loadMain()
    },

    created() {

        this.actualizarParamentro()
    },


    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
        // -- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },


        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////


        //-- cargar Parametros de inicio del componente --
        async loadMain() {
            this.filter = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_nivel: '',
                id_periodo: '',
                id_grado: '',
                id_seccion: '',
                id_alumno: '',
                id_tipo_incidencia: ''
            }

            this.getNivel(this.datoLogin.id_ano_lectivo)
            this.getIncidenciaCoductual(this.filter)
            this.getTipoIncidencia()
        },


        //-------mostrar registros en los selects ------------
        async getIncidenciaCoductual(filter) {

            try {
                let response = await axios.post(`/evaluacion/incidencia/view/`, { filter })
                this.data = response.data
                console.log("data", this.data)
                if (this.data.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No se encontrarón registros`, tiempo: null })
                }

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }


        },


        async getPeriodo(id_colegio, id_ano_lectivo, id_nivel) {
            let params = { id_colegio, id_ano_lectivo, id_nivel }
            try {
                let response = await axios.post(`/sistema/integral/getPeriodo/`, { filter: params })
                this.listPeriodo = response.data


            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }


        },

        async getNivel(id_ano_lectivo) {
            let params = { id_ano_lectivo, id_colegio: sessionStorage.id_colegio }
            try {

                let response = await axios.post(`/sistema/integral/getNivelAdm/`, { filter: params })
                console.log("nivel", response)
                this.listNivel = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },



        async getGrado(id_colegio, id_nivel) {
            let params = { id_colegio, id_nivel }
            try {

                let response = await axios.post(`/sistema/integral/getGradoAdm/`, { filter: params })
                this.listGrado = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },


        async getSeccion(id_colegio, id_grado) {
            let params = { id_colegio, id_grado }
            try {

                let response = await axios.post(`/sistema/integral/getSeccionAdm/`, { filter: params })
                this.listSeccion = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },


        async getAlumno(id_colegio, id_ano_lectivo, id_seccion) {
            let params = { id_colegio, id_ano_lectivo, id_seccion }

            try {
                let response = await axios.post(`/sistema/integral/getAlumnoSeccion/`, { filter: params })
                this.listAlumno = response.data.result
                if (response.data.length == 0)
                    this.setEnviarMens({ tipo: "W", mensaje: `No existen alumno para la sección seleccionada `, tiempo: null })
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },


        async getTipoIncidencia() {

            try {
                let response = await axios.get(`/administrativo/manualidades/incidencias/tipo/`)
                this.listTipoIncidencia = response.data
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },



        eventNivel(id_nivel) {
            // this.setEnviarMens({tipo:"E", mensaje: `Nivel ${id_nivel}`, tiempo:null})
            this.listGrado = []
            this.filter.id_grado = ''
            this.listSeccion = []
            this.filter.id_seccion = ''
            this.listAlumno = []
            this.filter.id_alumno = ''
            this.getPeriodo(this.datoLogin.id_colegio, this.datoLogin.id_ano_lectivo, id_nivel)
            this.getGrado(this.datoLogin.id_colegio, id_nivel)

        },

        eventPeriodo(id_periodo) {
            // this.setEnviarMens({tipo:"E", mensaje: `Periodo ${id_periodo}`, tiempo:null})
            console.log(`Periodo: ${id_periodo}`)
        },


        eventGrado(id_grado) {
            // this.setEnviarMens({tipo:"E", mensaje: `Grado ${id_grado}`, tiempo:null})
            this.listSeccion = []
            this.filter.id_seccion = ''
            this.listAlumno = []
            this.filter.id_alumno = ''
            this.getSeccion(this.datoLogin.id_colegio, id_grado)
            this.getIncidenciaCoductual(this.filter)
        },

        eventSeccion(id_seccion) {
            // this.setEnviarMens({tipo:"E", mensaje: `Seccion ${id}`, tiempo:null})
            this.listAlumno = []
            this.filter.id_alumno = ''
            this.getAlumno(this.datoLogin.id_colegio, this.datoLogin.id_ano_lectivo, id_seccion)
            this.getIncidenciaCoductual(this.filter)
        },

        ///////////////////////////////////////////////////
        //-- Componente de  Configuracion de colegio  -----
        ///////////////////////////////////////////////////

        addItem() {
            //this.setEnviarMens({tipo:"W", mensaje: `Agregar Formulario`, tiempo:null})
            this.parametroConfig = { evento: "add" }
            this.compName = "ConductualFormComp"
            this.estadoModalConfig = true
        },

        editItem(item) {
            // this.setEnviarMens({tipo:"W", mensaje: `Editar Formulario`, tiempo:null})
            this.parametroConfig = { evento: "edit", item }
            this.compName = "ConductualFormComp"
            this.estadoModalConfig = true
        },

        viewItem(item) {
            // this.setEnviarMens({tipo:"W", mensaje: `Editar Formulario`, tiempo:null})
            this.parametroConfig = { evento: "view", item }
            this.compName = "ConductualFormComp"
            this.estadoModalConfig = true
        },

        /*******cerrar modal y blanquear arreglos */
        closeModal() {
            this.estadoModalConfig = false
            this.loadMain()
        },



        async deleteItem(id) {
            this.confirm.active = true;
            this.confirm.title = "¿Está seguro de eliminar este registro?";
            this.confirm.id = id;
        },



        // confirm dialog event
        async deleted() {
            try {
                const idDelete = this.confirm.id

                const resp = await axios.delete("/evaluacion/incidencia/" + idDelete)
                this.clear_confirm()
                this.getIncidenciaCoductual(this.filter)

                this.setEnviarMens({
                    tipo: resp.data.messageT,
                    mensaje: resp.data.message,
                    tiempo: null,
                });
            } catch (error) {
                this.setEnviarMens({
                    tipo: "E",
                    mensaje: "No se pudo eliminar",
                    tiempo: null,
                });
            }

        },

        cancelar() {
            this.clear_confirm();
        },


        clear_confirm() {
            this.confirm.id = 0;
            this.confirm.title = "";
            this.confirm.active = false;
        },



    },

}




</script>